import React from 'react'
import moment from 'moment'

export default function useLastWeekNumber () {
  return moment().subtract(1, 'week').isoWeek()
}
